import Reveal from '@/components/base/Reveal';
import { heroStats, heroTags } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-32 -top-24 h-80 w-80 rounded-full bg-accent-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-primary-100/50 blur-3xl" />

      <div className="relative mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-12 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-2 lg:items-center lg:gap-16 lg:py-24">
        <Reveal>
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-800">
              <i className="ri-fire-line flex h-3.5 w-3.5 items-center justify-center text-sm" />
              每日更新的热点榜单
            </span>
            <span className="hidden rounded-full border border-background-200 px-3.5 py-1.5 text-xs text-foreground-600 sm:inline-flex">
              热度每分钟刷新
            </span>
          </div>

          <h1 className="mt-6 font-heading text-[40px] font-bold leading-[1.12] tracking-tight text-foreground-950 md:text-[56px]">
            热点黑料
            <span className="mt-3 block text-lg font-semibold text-primary-700 md:text-[22px]">
              热点黑料榜单 · 全网合集 · 最全盘点
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-[15px] leading-8 text-foreground-600">
            每日更新的热点黑料榜单，TOP10 排行、全网合集、最全整理，一次性看够近期热点人物与事件的争议内容，吃瓜不迷路。
            所有条目均以公开渠道信息为基础整理，标注收集时间与来源线索。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              <i className="ri-bar-chart-2-line flex h-4 w-4 items-center justify-center text-base" />
              查看今日 TOP10
            </a>
            <a
              href="#collection"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold whitespace-nowrap text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-stack-line flex h-4 w-4 items-center justify-center text-base" />
              浏览全网合集
            </a>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs text-foreground-600 md:text-[13px]">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal delay={120}>
          <div className="relative lg:pl-4">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=anonymous%20silhouette%20of%20a%20figure%20behind%20frosted%20glass%20with%20scattered%20newspaper%20clippings%20and%20a%20glowing%20spotlight%20in%20a%20moody%20red%20glow%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=880&height=1100&seq=hl-hero-01&orientation=portrait"
                alt="热点黑料榜单封面图 热点黑料盘点"
                title="热点黑料榜单 今日封面 热点黑料合集"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="absolute left-3 top-3 flex items-center gap-2 rounded-md bg-accent-500 px-3.5 py-2 text-background-50 dark:text-foreground-950 md:left-6 md:top-6">
              <i className="ri-trophy-line flex h-4 w-4 items-center justify-center text-base" />
              <span className="text-xs font-bold">今日 TOP1 · 热度 98.6万</span>
            </div>

            <div className="absolute -bottom-4 left-4 right-4 rounded-lg border border-background-200 bg-background-50 p-4 md:-bottom-6 md:left-8 md:right-8 md:p-5">
              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="font-label text-xs uppercase tracking-[0.18em] text-foreground-500">
                    当前热榜条目
                  </p>
                  <p className="mt-1.5 font-heading text-base font-bold text-foreground-950">
                    96 条 · 覆盖 4 大圈层
                  </p>
                </div>
                <span className="flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-semibold text-primary-800">
                  <i className="ri-time-line flex h-3.5 w-3.5 items-center justify-center text-sm" />
                  09:40
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="h-6 lg:h-8" />
    </section>
  );
}